// Components
import PostsList from "../components/PostsList";

const Posts = () => {
  return <PostsList />;
};

export default Posts;
